import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import { toTitleCase } from "../../../Utils/helper";
import { useAuth } from "../../../Utils/Auth";
import Loader from "../../loader";
import { toast } from "react-toastify";
import Transaction_Service from '../../../Services/apiService/transaction-service'
import bankService from '../../../Services/apiService/bank-service';
const CreateTransaction = (props) => {
  const auth = useAuth();

  const customerRef = useRef(null);
  const websiteRef = useRef(null);
  const bankRef = useRef(null);

  const [formData, setFormData] = useState({
    customerName: "",
    transactionId: "",
    bankName: "",
    websiteName: "",
    amount: "",
    bonus: "",
    bankCharges: "",
    paymentMethod: "",
    remarks: "",
  });
  const [errMessage, setErrMessage] = useState({
    customerName: "",
    transactionId: "",
    bankName: "",
    websiteName: "",
    amount: "",
    bonus: "",
    bankCharges: "",
    paymentMethod: "",
    remarks: "",
  });
  const [banks, setBanks] = useState([]);
  const [website, setWebsite] = useState([]);
  const [customer, setCustomer] = useState([]);
  const bankDebounceTimer = useRef(null);
  const websiteDebounceTimer = useRef(null);
  const customerDebounceTimer = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isAiLoading, setIsAiLoading] = useState(false);

  const debounce = (func, delay, timerRef) => {
    return (...args) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const debouncedFetchBanks = debounce(fetchBanks, 300, bankDebounceTimer);
  const debouncedFetchWebsites = debounce(fetchWebsite, 300, websiteDebounceTimer);
  const debouncedFetchCustomers = debounce(fetchCustomer, 300, customerDebounceTimer);

  async function fetchBanks(search) {
    try {
      const res = await bankService.getActiveBank(auth.user, search);
      setBanks(res.data.data);
    } catch (error) {
      console.error("Error fetching banks:", error);
    }
  }

  async function fetchWebsite(search) {
    try {
      const res = await Transaction_Service.getActiveWebsite(auth.user, search);
      setWebsite(res.data.data);
    } catch (error) {
      console.error("Error fetching websites:", error);
    }
  }

  async function fetchCustomer(search) {
    try {
      const res = await Transaction_Service.getCustomerName(auth.user, search);
      setCustomer(res.data.data);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  }

  useEffect(() => {
    function handleClickOutside(event) {
      // CUSTOMER
      if (customerRef.current && !customerRef.current.contains(event.target)) {
        setCustomer([]);
      }
      // WEBSITE
      if (websiteRef.current && !websiteRef.current.contains(event.target)) {
        setWebsite([]);
      }
      // BANK
      if (bankRef.current && !bankRef.current.contains(event.target)) {
        setBanks([]);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      if (bankDebounceTimer.current) clearTimeout(bankDebounceTimer.current);
      if (websiteDebounceTimer.current) clearTimeout(websiteDebounceTimer.current);
      if (customerDebounceTimer.current) clearTimeout(customerDebounceTimer.current);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getLiveValidationError = (fieldName, value) => {
    switch (fieldName) {
      case "customerName":
      case "transactionId":
      case "bankName":
      case "websiteName":
      case "paymentMethod":
      case "remarks":
        return value.trim() ? "" : toTitleCase(`${fieldName.replace(/([A-Z])/g, ' $1')} is required.`);

      case "amount":
        if (value && (isNaN(value) || Number(value) < 0)) return toTitleCase("Amount must be a positive number or 0.");
        return "";

      case "bonus":
      case "bankCharges":
        if (value && (isNaN(value) || Number(value) < 0)) {
          return toTitleCase(`${fieldName === "bonus" ? "Bonus" : "Bank charges"} must be a positive number or 0.`);
        }
        return "";

      default:
        return "";
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "amount" || name === "bonus" || name === "bankCharges") {
      const regex = /^(?:[1-9]\d*|0)?(?:\.\d{0,2})?$/;
      if (value === "" || regex.test(value)) {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    setErrMessage((prev) => ({
      ...prev,
      [name]: getLiveValidationError(name, value),
    }));

    if (name === "bankName") {
      debouncedFetchBanks(value);
    }
    if (name === "websiteName") {
      debouncedFetchWebsites(value);
    }
    if (name === "customerName") {
      debouncedFetchCustomers(value);
    }
  };

  const handleClearForm = () => {
    setFormData({
      customerName: "",
      transactionId: "",
      bankName: "",
      websiteName: "",
      amount: "",
      bonus: "",
      bankCharges: "",
      paymentMethod: "",
      remarks: "",
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isFormValid = handleValidation();
    if (isFormValid) {
      const payload = {
        transactionID: formData.transactionId,
        transactionType: props.callingParrent,
        amount: Number(formData.amount),
        paymentMethod: formData.paymentMethod,
        userName: formData.customerName,
        websiteName: formData.websiteName,
        bankName: formData.bankName,
        bankCharges: Number(formData.bankCharges),
        bonus: Number(formData.bonus),
        remarks: formData.remarks,
      }
      // if (props.callingParrent === "Deposit") {
      //   delete payload.bankCharges;
      // } else {
      //   delete payload.bonus;
      // }
      try {
        setIsLoading(true)
        const res = await Transaction_Service.createTransaction(auth.user, payload);
        if (res?.data) {
          toast.success(toTitleCase(res.data.message || "Success"));
          handleClearForm();
        }
      }
      catch (err) {
        toast.error(toTitleCase(err.response.data.errMessage || "some thing went wrong"))
      }
      setIsLoading(false)
    }
  };

  const handleValidation = () => {
    const newErrors = {};

    if (props.callingParrent === "Deposit") {
      delete formData.bankCharges;
    } else {
      delete formData.bonus;
    }

    Object.entries(formData).forEach(([fieldName, value]) => {
      let error = "";

      switch (fieldName) {
        case "customerName":
          if (!value.trim()) error = toTitleCase("Customer name is required.");
          break;

        case "transactionId":
          if (!value.trim()) error = toTitleCase("Transaction ID is required.");
          break;

        case "bankName":
          if (!value.trim()) error = toTitleCase("Bank name is required.");
          break;

        case "websiteName":
          if (!value.trim()) error = toTitleCase("Website name is required.");
          break;

        case "amount":
          if (!value.trim()) {
            error = toTitleCase("Amount is required.");
          } else if (isNaN(value) || Number(value) < 0) {
            error = toTitleCase("Enter a valid amount.");
          }
          break;
        case "bonus":
          if (value === "" || isNaN(value) || Number(value) < 0) {
            error = toTitleCase("Bonus must be a positive number or 0.");
          }
          break;

        case "bankCharges":
          if (value === "" || isNaN(value) || Number(value) < 0) {
            error = toTitleCase("Bank charges must be a positive number or 0.");
          }
          break;

        case "paymentMethod":
          if (!value.trim()) error = toTitleCase("Payment method is required.");
          break;

        case "remarks":
          if (!value.trim()) error = toTitleCase("remarks is required.");
          break;

        default:
          break;
      }

      newErrors[fieldName] = error;
    });

    setErrMessage(newErrors);
    return Object.values(newErrors).every((err) => !err);
  };


  const messages = [
    `Hi I'm ${auth.user.userName}, completing this ${props.callingParrent} transaction.`,
    `Hello! ${auth.user.userName} here, processing the ${props.callingParrent} transaction.`,
    `Transaction processed by ${auth.user.userName}.`,
    `${auth.user.userName} is handling this ${props.callingParrent} transaction now.`,
    `This ${props.callingParrent} transaction is being handled by ${auth.user.userName}.`,
    `Processing the ${props.callingParrent} transaction – ${auth.user.userName} at your service.`,
    `${auth.user.userName} just initiated the ${props.callingParrent} transaction.`,
    `Currently working on the ${props.callingParrent} transaction – ${auth.user.userName}.`,
    `${auth.user.userName} has taken charge of this ${props.callingParrent} transaction.`,
    `The ${props.callingParrent} transaction is underway with ${auth.user.userName}.`,
    `${auth.user.userName} is currently completing the ${props.callingParrent} transaction.`,
    `This ${props.callingParrent} transaction is in progress by ${auth.user.userName}.`,
    `You’re all set – ${auth.user.userName} is finalizing the ${props.callingParrent} transaction.`,
    `${auth.user.userName} has successfully started the ${props.callingParrent} transaction.`,
    `Rest assured, ${auth.user.userName} is managing your ${props.callingParrent} transaction.`,
  ];


  const handleAiWrite = async () => {
    setIsAiLoading(true);
    // Pick a random index
    const randomIndex = Math.floor(Math.random() * messages.length);
    const aiText = toTitleCase(messages[randomIndex]);

    setTimeout(() => {
      setFormData((prev) => ({
        ...prev,
        remarks: aiText,
      }));
      setErrMessage((prev) => ({
        ...prev,
        remarks: getLiveValidationError("remarks", aiText),
      }));
      setIsAiLoading(false);
    }, 1000); // Simulate delay for UX
  };



  


  return (
    <div className="simplified-form-container-fluid" style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}>
      <form onSubmit={handleSubmit} className="simplified-deposit-form" style={{
        background: "#fff",
        padding: "40px",
        borderRadius: "8px",
        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
        width: "100%",
        maxWidth: "1000px",
        maxHeight: "80vh",
         overflowY: "auto"
      }}>
        <h4>{props?.callingParrent}</h4>
        {/* Customer */}
        <div className="form-group dropdown-container" ref={customerRef}>
          <label htmlFor="customerName">Customer</label>
          <input
            type="text"
            className="form-control "
            id="customerName"
            name="customerName"
            value={formData.customerName}
            onChange={handleChange}
            placeholder="Search Customer..."
          />
          {errMessage.customerName && (
            <small className="text-danger">{errMessage.customerName}</small>
          )}
          {customer.length > 0 && (
            <ul className="search-dropdown">
              {customer.map((cust, index) => (
                <li
                  key={index}
                  tabIndex={0}
                  onClick={() => {
                    const value = cust.userName;
                    setFormData((prev) => ({
                      ...prev,
                      customerName: cust.userName,
                    }));
                    setErrMessage((prev) => ({
                      ...prev,
                      customerName: getLiveValidationError("customerName", value),
                    }));
                    setCustomer([]);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault(); // prevent scrolling on Space
                      const value = cust.userName;
                      setFormData((prev) => ({
                        ...prev,
                        customerName: cust.userName,
                      }));
                      setErrMessage((prev) => ({
                        ...prev,
                        customerName: getLiveValidationError("customerName", value),
                      }));
                      setCustomer([]);
                    }
                  }}
                >
                  {cust.userName}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Transaction ID */}
        <div className="form-group">
          <label htmlFor="transactionId">Transaction ID</label>
          <input
            type="text"
            className="form-control "
            id="transactionId"
            name="transactionId"
            value={formData.transactionId}
            onChange={handleChange}
            placeholder="Enter Transaction Id"
          />
          {errMessage.transactionId && (
            <small className="text-danger">{errMessage.transactionId}</small>
          )}
        </div>

        {/* Website */}
        <div className="form-group dropdown-container" ref={websiteRef}>
          <label htmlFor="websiteName">Website</label>
          <input
            type="text"
            className="form-control "
            id="websiteName"
            name="websiteName"
            value={formData.websiteName}
            onChange={handleChange}
            placeholder="Search Website..."
            autoComplete="off"
          />
          {errMessage.websiteName && (
            <small className="text-danger">{errMessage.websiteName}</small>
          )}
          {website.length > 0 && (
            <ul className="search-dropdown">
              {website.map((site, index) => (
                <li
                  key={index}
                  tabIndex={0} // 👈 makes list item focusable
                  onClick={() => {
                    const value = site.websiteName;
                    setFormData((prev) => ({
                      ...prev,
                      websiteName: site.websiteName,
                    }));
                    setErrMessage((prev) => ({
                      ...prev,
                      websiteName: getLiveValidationError("websiteName", value),
                    }));
                    setWebsite([]);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault(); // prevents page scroll on Space
                      const value = site.websiteName;
                      setFormData((prev) => ({
                        ...prev,
                        websiteName: site.websiteName,
                      }));
                      setErrMessage((prev) => ({
                        ...prev,
                        websiteName: getLiveValidationError("websiteName", value),
                      }));
                      setWebsite([]);
                    }
                  }}
                >
                  {site.websiteName}
                </li>
              ))}
            </ul>

          )}
        </div>

        {/* Amount */}
        <div className="form-group">
          <label htmlFor="amount">Amount</label>
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">Rs.</span>
            </div>
            <input
              type="number"
              className="form-control inp-ammount "
              id="amount"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              placeholder="Enter Amount"
              min="0"
              pattern="^[1-9]\d*(\.\d{1,2})?$"
            />
          </div>
          {errMessage.amount && (
            <small className="text-danger">{errMessage.amount}</small>
          )}
        </div>

        {/* Bonus or Bank Charges */}
        {props.callingParrent === "Deposit" ? (
          <div className="form-group">
            <label htmlFor="bonus">Bonus</label>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">Rs.</span>
              </div>
              <input
                type="number"
                className="form-control inp-ammount "
                id="bonus"
                name="bonus"
                value={formData.bonus}
                onChange={handleChange}
                placeholder="Enter Bonus"
                min="0"
              />
            </div>
            {errMessage.bonus && (
              <small className="text-danger">{errMessage.bonus}</small>
            )}
          </div>
        ) : (
          <div className="form-group">
            <label htmlFor="bankCharges">Bank Charges</label>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">Rs.</span>
              </div>
              <input
                type="number"
                className="form-control inp-ammount "
                id="bankCharges"
                name="bankCharges"
                value={formData.bankCharges}
                onChange={handleChange}
                placeholder="Enter Bank Charges"
                min="0"
              />
            </div>
            {errMessage.bankCharges && (
              <small className="text-danger">{errMessage.bankCharges}</small>
            )}
          </div>
        )}

        {/* Bank */}
        <div className="form-group dropdown-container" ref={bankRef}>
          <label htmlFor="bankName">Bank</label>
          <input
            type="text"
            className="form-control "
            id="bankName"
            name="bankName"
            value={formData.bankName}
            onChange={handleChange}
            placeholder="Search Bank..."
            autoComplete="off"
          />
          {errMessage.bankName && (
            <small className="text-danger">{errMessage.bankName}</small>
          )}
          {banks.length > 0 && (
            <ul className="search-dropdown">
              {banks.map((bank, index) => (
                <li
                  key={index}
                  tabIndex={0} 
                  onClick={() => {
                    const value = bank.bankName;
                    setFormData((prev) => ({
                      ...prev,
                      bankName: bank.bankName,
                    }));
                    setErrMessage((prev) => ({
                      ...prev,
                      bankName: getLiveValidationError("bankName", value),
                    }));
                    setBanks([]);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault(); // stop scrolling on space
                      const value = bank.bankName;
                      setFormData((prev) => ({
                        ...prev,
                        bankName: bank.bankName,
                      }));
                      setErrMessage((prev) => ({
                        ...prev,
                        bankName: getLiveValidationError("bankName", value),
                      }));
                      setBanks([]);
                    }
                  }}
                >
                  {bank.bankName}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Payment Method */}
        <div className="form-group">
          <label htmlFor="paymentMethod">Payment Method</label>
          <select
            className="form-control"
            id="paymentMethod"
            name="paymentMethod"
            value={formData.paymentMethod}
            onChange={handleChange}
            style={{
              height: 'auto',
              minHeight: '34px'
            }}
            
          >
            <option value="">Select Method</option>
            <option value="UPI">UPI</option>
            <option value="IMPS">IMPS</option>
            <option value="NEFT">NEFT</option>
            <option value="RTGS">RTGS</option>
          </select>
          {errMessage.paymentMethod && (
            <small className="text-danger">{errMessage.paymentMethod}</small>
          )}
        </div>

        {/* Remarks */}
        <div className="form-group">
          <label htmlFor="remarks">Remarks</label>
          <div style={{ position: "relative" }}>
            <textarea
              className="form-control"
              id="remarks"
              name="remarks"
              value={formData.remarks}
              onChange={handleChange}
              placeholder="Remarks..."
              disabled={isAiLoading}
            />
            <button
              type="button"
              className="ai-button"
              onClick={handleAiWrite}
              disabled={isAiLoading}
            >
              {isAiLoading ? "Writing..." : " AI Write "}
            </button>
          </div>
          {errMessage.remarks && (
            <small className="text-danger">{errMessage.remarks}</small>
          )}
        </div>

        {/* Form Actions */}
        <div className="form-actions" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button type="submit" className="btn btn-primary" style={{ backgroundColor: "#4682b4", flex: 1 }}>
            {props?.callingParrent}
          </button>
          <button type="button" className="btn btn-light" onClick={handleClearForm} style={{ flex: 1 }}>
            Clear
          </button>
        </div>
      </form>

      <Loader
        isLoading={isLoading}
        spinnerType="bar"
        color="#ff5722"
        message="Processing..."
      />
    </div>
  );
};

export default CreateTransaction;